export const themes = {
  osrouter: {
    mainBackground: '#15151f',
    secondaryBackground: '#0b0b12',
    textColor: '#ededf5',
    primaryActionColor: '#7c6cff',
    buttonTextColor: '#ffffff',
  },
  dark: {
    mainBackground: '#1F2937',
    secondaryBackground: '#111827',
    textColor: '#F9FAFB',
    primaryActionColor: '#22D3EE',
    buttonTextColor: '#000000',
  },
  light: {
    mainBackground: '#FFFFFF',
    secondaryBackground: '#F9FAFB',
    textColor: '#111827',
    primaryActionColor: '#06B6D4',
    buttonTextColor: '#FFFFFF',
  },
};

export const applyTheme = (themeName) => {
  const theme = themes[themeName] || themes.osrouter;
  const root = document.documentElement;
  root.style.setProperty('--theme-main-bg', theme.mainBackground);
  root.style.setProperty('--theme-secondary-bg', theme.secondaryBackground);
  root.style.setProperty('--theme-text', theme.textColor);
  root.style.setProperty('--theme-primary', theme.primaryActionColor);
  root.style.setProperty('--theme-button-text', theme.buttonTextColor);
  root.setAttribute('data-theme', themeName);
};
